<!-- 系统更新日志 -->
<template>
    <div class="container">
        <div v-if="dataList.length" class="content">
            <div v-for="(item, index) of dataList" :key="index" class="dis-flex">
                <template v-if="dataList.length == 1">
                    <div class="line-div">
                        <div class="rounds-active">
                            <div class="round-active"></div>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div v-if="index == 0" class="line-div">
                        <div class="rounds-active">
                            <div class="round-active"></div>
                        </div>
                        <div class="line-active"></div>
                    </div>
                    <div v-else class="line-div">
                        <div class="rounds">
                            <div class="round"></div>
                        </div>
                        <div v-if="index != dataList.length - 1" class="line"></div>
                    </div>
                </template>
                <div class="content-div">
                    <div class="flex-sb">
                        <div class="list-title">{{item.title}}</div>
                        <div class="list-time">{{item.created_at}}</div>
                    </div>
                    <div class="list-version">版本号：{{item.version}}</div>
                    <div class="list-reason">{{item.reason}}</div>
                    <div v-for="(e, j) of item.show_imgs" :key="j" class="show-image-div">
                        <img :src="e" class="show-image" @click="seeImg(e)">
                    </div>
                </div>
            </div>
            <div v-if="dataList.length > 10 && btn_value" class="check-btn" @click="pageChange">查看更多</div>
        </div>
        <div v-else class="none-div">暂无数据~</div>
    </div>
</template>

<script>
import { 
    version_index, 
} from '@/api/index';
export default {
    data() {
        return {
            storePrams: {
                page: 1,
                limit: 10,
            },
            dataList: [],
            btn_value: true,
        };
    },
    mounted() {
        this.getList();
    },
    methods: {
        getList(){
            version_index(this.storePrams).then((res) => {
                this.btn_value = true;
                let data = res.data.data
                if (data.length != 0) {
                    data.forEach(item => {
                        this.dataList.push(item)
                    })
                }else {
                    this.$Message.error('暂无更多数据~');
                    this.btn_value = false;
                }
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        pageChange() {
            this.storePrams.page ++;
            this.getList();
        },
        seeImg(item){
            if(item){
                window.open(item);
            }else{
                this.$Message.error('请先上传图片');
            }
        },
    },
};
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
}
.content {
    padding: 24px 24px 0 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 4px;
    height: 100%;
}
.dis-flex {
    display: flex;
}
.line-div {
    display: flex;
    align-items: center;
    flex-direction: column;
}
.line-active {
    width: 2px;
    flex: 1;
    border-left: 2px dashed #FF761D;
}
.rounds-active {
    width: 20px;
    height: 20px;
    min-width: 20px;
    min-height: 20px;
    max-width: 20px;
    max-height: 20px;
    border-radius: 50%;
    border: 2px solid #FF761D;
    padding: 3px;
}
.round-active {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: #FF761D;
}
.line {
    width: 2px;
    flex: 1;
    border-left: 2px dashed #959595FF;
}
.rounds {
    width: 20px;
    height: 20px;
    min-width: 20px;
    min-height: 20px;
    max-width: 20px;
    max-height: 20px;
    border-radius: 50%;
    border: 2px solid #959595FF;
    padding: 3px;
}
.round {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: #959595FF;
}
.content-div {
    text-align: left;
    font-size: 16px;
    color: #666666;
    width: 100%;
    margin: -6px 0 24px 24px;
}
.list-title {
    font-size: 20px;
    color: #333333;
}
.list-time {
    font-size: 18px;
    color: #666666;
}
.list-version {
    margin: 6px 0;
}
.show-image-div {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}
.show-image {
    width: 200px;
    height: 100px;
    border: 1px dashed #ccc;
    border-radius: 4px;
    margin-top: 6px;
    object-fit: cover;
    cursor: pointer;
}
.check-btn {
    font-size: 18px;
    color: #FF761D;
    margin: 0 0 24px 44px;
    cursor: pointer;
}
.none-div {
    font-size: 13px;
    color: #808080;
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 4px;
    height: 100%;
}
</style>